import React from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";

const ComboHourPeriod = ({
                           propTitle = '수신 시간',
                           propStartHr,
                           propEndHr,
                           propOnChangeFrom,
                           propOnChangeTo
                         }) => {

  return (
      <Form.Group as={Row} controlId='forml2IpAddr'>
        <Form.Label column md={3} className={'label text-end fw-bold'}>
          <span className={"text-danger"}>* </span>{propTitle}
        </Form.Label>
        <Col md={9}>
          <Row>
            <Col md={3}>
              <Form.Select
                  aria-label="Default select example"
                  className={"input input-select time pe-0"}
                  onChange={propOnChangeFrom}
                  defaultValue={propStartHr}
                  key={propStartHr}
              >
                <option value={"00"}>00시</option>
                <option value={"01"}>01시</option>
                <option value={"02"}>02시</option>
                <option value={"03"}>03시</option>
                <option value={"04"}>04시</option>
                <option value={"05"}>05시</option>
                <option value={"06"}>06시</option>
                <option value={"07"}>07시</option>
                <option value={"08"}>08시</option>
                <option value={"09"}>09시</option>
                <option value={"10"}>10시</option>
                <option value={"11"}>11시</option>
                <option value={"12"}>12시</option>
                <option value={"13"}>13시</option>
                <option value={"14"}>14시</option>
                <option value={"15"}>15시</option>
                <option value={"16"}>16시</option>
                <option value={"17"}>17시</option>
                <option value={"18"}>18시</option>
                <option value={"19"}>19시</option>
                <option value={"20"}>20시</option>
                <option value={"21"}>21시</option>
                <option value={"22"}>22시</option>
                <option value={"23"}>23시</option>
              </Form.Select>
            </Col>
            <Col md={1} className={"text-center"}>
              ~
            </Col>
            <Col md={3}>
              <Form.Select
                  aria-label="Default select example"
                  className={"input input-select time pe-0"}
                  onChange={propOnChangeTo}
                  defaultValue={propEndHr}
                  key={propEndHr}
              >
                <option value={"00"}>00시</option>
                <option value={"01"}>01시</option>
                <option value={"02"}>02시</option>
                <option value={"03"}>03시</option>
                <option value={"04"}>04시</option>
                <option value={"05"}>05시</option>
                <option value={"06"}>06시</option>
                <option value={"07"}>07시</option>
                <option value={"08"}>08시</option>
                <option value={"09"}>09시</option>
                <option value={"10"}>10시</option>
                <option value={"11"}>11시</option>
                <option value={"12"}>12시</option>
                <option value={"13"}>13시</option>
                <option value={"14"}>14시</option>
                <option value={"15"}>15시</option>
                <option value={"16"}>16시</option>
                <option value={"17"}>17시</option>
                <option value={"18"}>18시</option>
                <option value={"19"}>19시</option>
                <option value={"20"}>20시</option>
                <option value={"21"}>21시</option>
                <option value={"22"}>22시</option>
                <option value={"23"}>23시</option>
              </Form.Select>
            </Col>
          </Row>
        </Col>

      </Form.Group>
  );
};

export default ComboHourPeriod;